import useLocationQueryParams from "core/hooks/useLocationQueryParams";

const useIsSide = () => {
  const query = useLocationQueryParams();
  const step = query.get("step");
  return step !== "1";
};

export default useIsSide;
